import cfg from '../services/configuration/PropertiesConfiguration'

let Cookies = require('js-cookie')

export class LoginService {

  constructor (axios) {
    this.axios = axios
  }

  // this method is used for member login and returns security token as response
  login (credentials) {
    return this.axios.post(cfg.loginEndPoint, credentials)
  }

  //  this method is used to set the security token and logged in username to expire in 20 minutes
  setAuthToken (token, username) {
    var inTwentyMinutes = new Date(new Date().getTime() + 20 * 60 * 1000)
    Cookies.set('securityToken', token, {expires: inTwentyMinutes})
    Cookies.set('loggedInUserName', username, {expires: inTwentyMinutes})
  }

  //  this method is used to save username in a cookie when remember me is selected
  saveUsername (username) {
    var inTwentyMinutes = new Date(new Date().getTime() + 20 * 60 * 1000)
    Cookies.set('username', username, { expires: inTwentyMinutes })
  }

  getSavedUsername () {
    return Cookies.get('username')
  }

  getLoggedInUserName () {
    return Cookies.get('loggedInUserName')
  }

  logout () {
    Cookies.remove('securityToken')
    Cookies.remove('loggedInUserName')
  }
}



// WEBPACK FOOTER //
// ./src/services/LoginService.js